import React from 'react';
import { Menu, Icon, Label, Popup, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export default function CitizenSidebar({
  t,
  activeItem,
  onItemClick,
  logout,
  questionnaireCompleted = false,
  servicesNotifications = 0,
  chatbotNotifications = 0,
  collapsed = false,
  setCollapsed = () => { }
}) {
  const itemStyle = { display: 'flex', alignItems: 'center', gap: 10 };

  const StartPill = () => (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '4px 10px',
          borderRadius: 9999,
          fontSize: 12,
          fontWeight: 600,
          background: 'linear-gradient(135deg, #FF7A00 0%, #FFB366 100%)',
          color: '#fff',
          boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
        }}
        title={t('Start here')}
      >
        <Icon name="play" style={{ margin: 0 }} />
        {t('Start here')}
      </span>
    </div>
  );

  const QuestionnaireBadge = () =>
    questionnaireCompleted ? (
      <Label size="mini" color="green" basic circular title={t('Completed')}>
        <Icon name="check" />
      </Label>
    ) : (
      <StartPill />
    );

  return (
    <div style={{ padding: 8 }}>
      {/* Header + collapse */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 8px 12px' }}>
        <Button
          basic
          icon
          aria-label={t('Toggle menu')}
          onClick={() => setCollapsed(v => !v)}
          style={{ boxShadow: 'none' }}
        >
          <Icon name={collapsed ? 'angle right' : 'angle left'} />
        </Button>
        {!collapsed && <div style={{ fontWeight: 600 }}>{t('Menu')}</div>}
      </div>

      <Menu fluid vertical secondary>
        {/* My Profile */}
        <Popup
          disabled={!collapsed}
          position="right center"
          content={t('Edit your personal details and data preferences')}
          trigger={
            <Menu.Item
              as={Link}
              to="/profile"
              name="profile"
              active={activeItem === 'profile'}
              onClick={onItemClick}
            >
              <div style={itemStyle}>
                <Icon name="user circle" color="blue" />
                {!collapsed && <span>{t('My Profile')}</span>}
              </div>
            </Menu.Item>
          }
        />

        {/* Questionnaire */}
        <Popup
          disabled={!collapsed}
          position="right center"
          content={
            questionnaireCompleted
              ? t('Review or update your questionnaire')
              : t('Start here to get personalized suggestions')
          }
          trigger={
            <Menu.Item
              as={Link}
              to="/questionnaire"
              name="questionnaire"
              active={activeItem === 'questionnaire'}
              onClick={onItemClick}
            >
              <div style={itemStyle}>
                <Icon
                  name={questionnaireCompleted ? 'clipboard check' : 'clipboard list'}
                  color={questionnaireCompleted ? 'green' : 'blue'}
                />
                {!collapsed && <span>{t('Questionnaire')}</span>}
              </div>
              {!collapsed && <div style={{ marginTop: 6 }}>{/* <QuestionnaireBadge /> */}</div>}
            </Menu.Item>
          }
        />

        {/* Chatbot (new, its own route and badge) */}
        {/*<Popup
          disabled={!collapsed}
          position="right center"
          content={t('The Zipster Chatbot')}
          trigger={
            <Menu.Item
              as={Link}
              to="/chatbot"
              name="chatbot"
              active={activeItem === 'chatbot'}
              onClick={onItemClick}
            >
              <div style={itemStyle}>
                <Icon name="chat" color="blue" />
                {!collapsed && <span>{t('Chatbot')}</span>}
                {chatbotNotifications > 0 && (
                  <Label color="red" floating size="mini" style={{ right: 0 }}>
                    {chatbotNotifications}
                  </Label>
                )}
              </div>
            </Menu.Item>
          }
        />*/}

        {/* Services */}
        <Popup
          disabled={!collapsed}
          position="right center"
          content={t('Services available to you')}
          trigger={
            <Menu.Item
              as={Link}
              to="/services"
              name="services"
              active={activeItem === 'services'}
              onClick={onItemClick}
            >
              <div style={itemStyle}>
                <Icon name="handshake" color="blue" />
                {!collapsed && <span>{t('Services')}</span>}
                {servicesNotifications > 0 && (
                  <Label color="red" floating size="mini" style={{ right: 0 }}>
                    {servicesNotifications}
                  </Label>
                )}
              </div>
            </Menu.Item>
          }
        />

        {/* Logout */}
        <Menu.Item
          as={Link}
          to="#logout"
          name="log out"
          active={activeItem === 'log out'}
          onClick={logout}
        >
          <div style={itemStyle}>
            <Icon name="log out" color="blue" />
            {!collapsed && <span>{t('Log Out')}</span>}
          </div>
        </Menu.Item>
      </Menu>
    </div>
  );
}